<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    ประวัติการเติมเงินมือถือ
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">



                    </div>

                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อสมาชิก หรือหมายเลขโทรศัพท์ เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-4 col-search" style="display: flex;">
                        <date-picker v-model="start_date" format="DD-MM-YYYY" placeholder="วันเริ่มต้น" />
                        <div style="width: 30px;">-</div>
                        <date-picker v-model="end_date" format="DD-MM-YYYY" placeholder="วันสิ้นสุด" />
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>

                <div class="body table-responsive" style="width:100%">
                    <div class="row">
                        <div class="col-sm-6" style="text-align: left;">
                            <div class="p-title">แสดงรายการระหว่าง วันที่ {{ start_date_text }} - {{ end_date_text }}
                            </div>
                        </div>
                        <div class="col-sm-5"> </div>
                        <div class="col-sm-1" style="text-align: right;">
                            <img src="static/images/excel.png" style="position: absolute;right: 10px;cursor: pointer;"
                                @click="download()" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b>จำนวนสั่งซื้อทั้งหมด:</b> {{ total | comma }} ครั้ง
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b> ราคารวมทั้งหมด:</b> {{ total_amount | comma2 }} บาท
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: left;">
                            <b> กำไรทั้งหมด:</b> {{ total_profit | comma2 }} บาท
                        </div>
                    </div>

                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>

                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">ชื่อสมาชิก</th>
                                    <th class="fn-th">หมายเลขโทรศัพท์</th>
                                    <!-- <th class="fn-th">แพคเกจ</th> -->
                                    <th class="fn-th">จำนวนเงิน</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">วันที่เติม</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page - 1) * perpage) + index + 1"></td>



                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.mobile_number }}</span>
                                    </td>
                                    <!-- <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td> -->
                                    <td style="text-align: center;">
                                        <span>{{ item.amount }}</span>
                                    </td>
                                       <td style="text-align: center;">
                                        <span style='color: orange;' v-if="item.status == 0">รอดำเนินการ</span> 
                                        <span style='color: green;' v-if="item.status == 1">สำเร็จ</span>
                                        <span style='color: red;' v-if="item.status > 1">ล้มเหลว{{ item.error_msg ? ' - ' + item.error_msg : '' }}</span>
                                        
                                    </td>
                                    
                                    <td style="text-align: center;">
                                        <span>{{ item.created_at | date }} </span>
                                    </td>


                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>

    </section>
</template>

<script>
import TopupMobileService from '../../service/TopupMobileService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import Paginate from 'vuejs-paginate'

export default {
    name: "TopupMobile",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            date: localStorage.getItem('date'),
            page: 1,
            perpage: 50,
            total: 0,
            total_amount: 0,
            total_profit: 0,
            pages: 0,
            items: [],
            key: "",
            file: null,
            searching: false,
            loading: false,
            start_date: null,
            start_date_text: "",
            end_date_text: "",
            end_date: null,
            search_params: {}
        }
    },
    async created() {
        this.start_date = new Date(this.date)
        this.end_date = new Date(this.date)

        this.search(1)
    },
    mounted() {

    },
    watch: {
        start_date(val) {
            this.end_date = val
        }
    },
    methods: {

        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            let start_date = moment(this.start_date).format('YYYY-MM-DD')
            let end_date = moment(this.end_date).format('YYYY-MM-DD')
            this.start_date_text = moment(this.start_date).format('DD/MM/YYYY')
            this.end_date_text = moment(this.end_date).format('DD/MM/YYYY')

            let response = await TopupMobileService.search(this.key, this.page, this.perpage, start_date, end_date)
          
            if (response.status) {
                let { page, perpage, total, pages, data, total_amount, total_profit } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data
                this.total_amount = total_amount
                this.total_profit = total_profit
            }
            this.loading = false
        },
        reset() {
            this.key = ""
            this.start_date = new Date(this.date)
            this.end_date = new Date(this.date)
            this.search(1)
        },


    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma(value, 2)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Manage/TopupMobile.vue